import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '拳皇档案馆',
  url: 'https://maishiranui-guide.com/',
  description: '不知火舞角色解析与攻略指南，深度解析角色背景、技能体系、连招攻略与文化影响',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://maishiranui-guide.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '拳皇档案馆',
  url: 'https://maishiranui-guide.com/',
  description: '专注于SNK格斗游戏角色攻略与深度解析的粉丝社区',
  foundingDate: '2024',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer support',
    email: 'contact@maishiranui-guide.com',
  },
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <SchemaOrg data={homeSchema} />
      <SchemaOrg data={orgSchema} />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedArticles />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}